import { WhatsApp } from "@mui/icons-material";
import { Box, Card, CardContent, CardHeader, Typography } from "@mui/material";
import React from "react";

type Props = {
  message: string;
};

const WhatsappPreview: React.FC<Props> = ({ message }) => (
  <Card>
    <CardHeader
      title="Preview do WhatsApp"
      subheader="A mensagem é atualizada automaticamente"
      avatar={<WhatsApp sx={{ color: "#25d366" }} />}
    />
    <CardContent
      sx={{
        backgroundColor: theme =>
          theme.palette.mode === "dark" ? "grey.900" : "#efeae2",
        minHeight: 410,
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          position: "relative",
          width: "94%",
          maxWidth: 560,
          borderRadius: 2,
          borderTopRightRadius: 0,
          backgroundColor: theme =>
            theme.palette.mode === "dark" ? "#075e54" : "#d9fdd3",
          color: theme =>
            theme.palette.mode === "dark" ? "common.white" : "grey.900",
          boxShadow: 1,
          px: 2,
          py: 1.5,
        }}
      >
        <Typography
          variant="body2"
          component="div"
          sx={{ whiteSpace: "pre-wrap", lineHeight: 1.55, wordBreak: "break-word" }}
        >
          {message}
        </Typography>
        <Typography
          variant="caption"
          component="div"
          textAlign="right"
          sx={{ mt: 0.5, opacity: 0.65 }}
        >
          Preview
        </Typography>
      </Box>
    </CardContent>
  </Card>
);

export default WhatsappPreview;
